import { Grid } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Cancel as CancelIcon
} from '@material-ui/icons';
import Button from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef } from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import CountUp from '../../components/Form/CountUp';
import { useAuth } from '../../hooks/auth';
import { MvmShedStartLoadUnloadPut } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import { TimeShortDataFormat } from '../../utils/componentUtils';
import utilsDate from '../../utils/Date';
import StringFormat from '../../utils/StringFormatUtil';
import { useStyles } from './Style';
import Box from '@mui/material/Box'
import alert from '../../pages/Concierge/Manage/images/alert.gif'

type Props = {
    reloadOnCLick?: any;
    getCounts?: any;
}

const CheckOut: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Checkout");
    const { user } = useAuth();
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const { isLoading, isFetching, data, refetch } = useQuery('getShedsUserMvmMonitorList', async () => {
        props.getCounts();
        var resp = await MvmApi.getShedsUserMvmMonitorList(+user.company.plantID, user.userName);
        return resp
    }, {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 1200, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (props.reloadOnCLick > 0) {
            refetch();
        }
    }, [props.reloadOnCLick]);

    const columns = [
        {
            style: { marginRight: "10px" },
            name: 'entryDate', //1
            label: " ",
            innerWidth: 10,
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (value == null) {
                        return (

                            <Button
                                variant="outlined"
                                style={{ height: "100%", width: "110%", fontSize: "0.7rem", padding: "2px" }}
                                onClick={() => OnCancelClick(tableMeta, "APAGAR", "CHECKIN")}
                            >
                                Voltar p/ CheckIn
                            </Button>
                        );
                    }
                    else {
                        return <span style={{ minWidth: 100 }}>{"              "}</span>;
                    }
                }
            },
        },
        {
            name: 'mvmCode',
            label: t("mvm"), //2
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return `${data[tableMeta.rowIndex].mvmCode} ${data[tableMeta.rowIndex].mviNumber != null ? `(` + data[tableMeta.rowIndex].mviNumber + `)` : ""}`;
                },
            }

        },
        {
            name: 'vehiclePlateNumber',
            label: t("plateNumber"), //3
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            //
            name: 'shedCode',
            label: t("place"), //4
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <span>{value + " - " + (tableMeta.rowData[4] == "D" ? "Descarga" : "Carga")}</span>
                }
            }
        },
        {
            name: 'shedType', //5
            label: t("modality"),
            options: {
                display: false
            }
        },
        {
            name: 'movementTypeDescription', //6
            label: t("movementTypeDescription"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
            }

        },
        {
            name: 'shippingSupplier', //7
            label: t("provider"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'windowStatus', //8
            label: t("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data[rowIndex].flagWindowStatus !== 'WHITE' ? data[rowIndex].flagWindowStatus : null,
                        color: data![rowIndex].flagWindowStatus != "YELLOW" && data![rowIndex].flagWindowStatus != "WHITE" ? "white" : "black"
                    }
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (value != null)
                        return (<>{value}</>);
                    else
                        return (<></>);
                },
            }
        },
        {
            name: 'presentationDateConcierge', //9
            label: t("ordinancePresentation"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: TimeShortDataFormat
            }
        },
        {
            name: 'plantEntranceDate', //10
            label: t("plantTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: ColorirTempoPlanta(rowIndex)
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (value != null) {

                        return (
                            <CountUp
                                date={value}
                            />)
                    }
                    else {
                        return <></>;
                    }
                }
            }
        },
        {
            name: 'checkinDate', //11
            label: t("shedArrival"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: TimeShortDataFormat
            }
        },
        {
            name: 'tolerance', //12
            label: t("tolerance"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: ColorirTempoRestante(rowIndex)
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    var checkinDateIndex = 10;
                    if (value != null) {
                        var values = value.split(":");
                        var dateLimit = Date.parse(tableMeta.rowData[checkinDateIndex]) +
                            utilsDate.IntervalToMilliseconds(values);

                        if (dateLimit < Date.now()) {
                            var dateL = new Date(tableMeta.rowData[checkinDateIndex]);
                            dateL.setTime(dateL.getTime() + utilsDate.IntervalToMilliseconds(values));

                            return (
                                <CountUp
                                    date={dateL}
                                    showSeconds={true}
                                />
                            )
                        }
                        else {
                            return (
                                <Countdown
                                    date={dateLimit}
                                    renderer={renderer}
                                    onComplete={refetch}
                                    zeroPadTime={2}
                                />)
                        }
                    }
                    else {
                        return <></>;
                    }
                }
            }
        },
        {
            name: 'entryDate', //13
            label: t("entryDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (value != null) {
                        return (
                            <Grid container spacing={0} alignItems="center">
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={3} alignItems="center" style={{ marginRight: "5px" }}>
                                    <span>{utilsDate.TimeShortByCompleteDate(value)}</span>
                                </Grid>
                                <Grid item xs={4} alignItems="center">
                                    <a href="#" onClick={() => CancelCargaClick(tableMeta.rowIndex, "APAGAR", "ENTRADA")}><CancelIcon style={{ transform: "translateY(8%)", color: "#EE0E0E" }} /></a>
                                </Grid>
                            </Grid>);
                    }
                    else {
                        return <></>;
                    }
                }
            }
        },
        {
            style: { marginRight: "10px" },
            name: 'shedType', //14
            label: t("start"),
            innerWidth: 10,
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center",
                    style: {
                        paddingRight: "30px"
                    }
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    var entryDateIndex = 12;
                    const iniciar = tableMeta.rowData[entryDateIndex] == null;
                    const carga = value == "C";

                    const textButton = (iniciar ? t("initiate") : t("finalize")) + ' ' + (carga ? t("load") : t("unload"));

                    return (
                        <Button
                            variant="outlined"
                            style={{ height: "100%", width: "110%", fontSize: "0.7rem", padding: "2px" }}
                            onClick={() => OnCargaClick(tableMeta.rowIndex, textButton)}>
                            {textButton}
                        </Button>
                    );
                }
            },
        },
        {
            name: 'flagWindowStatus', //15
            options: {
                display: false
            }
        },
        { //16
            name: 'shedMvmId',
            options: {
                display: false
            }
        },
        {
            name: 'isThereCriticalMaterial',
            label: t("isThereCriticalMaterial"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box display='flex' alignItems='center' justifyContent='center'>
                            {value == 'S' ?
                                (
                                    <>
                                        <img src={alert} title="Alerta" height={24} width={24} style={{ marginRight: 5, }} /> Sim
                                    </>
                                ) :
                                'Não'}
                        </Box>
                    );
                }
            }
        }
    ];

    function ColorirTempoPlanta(rowIndex: any) {

        var a = data![rowIndex]?.plantEntranceDate;
        if (!a)
            return {
                backgroundColor: 'white',
                color: color != 'white'
            }

        var color;

        const dataAtual = new Date(Date.now());
        const dataEntrada = new Date(a);

        var diffMs = dataAtual.getTime() - dataEntrada.getTime();
        let days = Math.floor(diffMs / 86400000)
        let hora = Math.floor((diffMs % 86400000) / 3600000) + (days * 24)

        if (hora >= 5) {
            color = "RED";
        } else if (hora < 4) {
            color = "GREEN";
        } else {
            color = "YELLOW";
        }

        return {
            backgroundColor: color,
            color: color != "YELLOW" ? "white" : "black"
        }
    }

    function ColorirTempoRestante(rowIndex: any) {

        var tolerance = data![rowIndex].tolerance

        if (tolerance == null)
            return {};

        var values = tolerance.split(":");

        if (data![rowIndex].checkinDate == null)
            return {};

        var limitDate = Date.parse(data![rowIndex].checkinDate!) +
            utilsDate.IntervalToMilliseconds(values);

        var halfLimitDate = Date.parse(data![rowIndex].checkinDate!) +
            (utilsDate.IntervalToMilliseconds(values) / 2);

        var currentDate = Date.now();

        var color;

        if (halfLimitDate > currentDate) {
            color = "GREEN";
        } else if (limitDate >= currentDate) {
            color = "YELLOW";
        } else {
            color = "RED";
        }

        return {
            backgroundColor: color,
            color: color != "YELLOW" ? "white" : "black"
        }
    }

    function OnCargaClick(rowIndex: number, buttonText: string) {
        let dataPut: MvmShedStartLoadUnloadPut = {
            id: data![rowIndex].mvmId,
            sheds: [{
                id: data![rowIndex].mvmShedId
            }]
        }

        if (buttonText.includes("Iniciar")/* || buttonText.includes("Descarga")*/) {
            setOpenBackdrop(true);

            MvmApi.startShedLoadUnload(dataPut)
                .then(() =>
                    enqueueSnackbar(_t("returnSubmitDeleteFormSuccess"), { variant: 'success' })
                )
                .finally(() => {
                    setOpenBackdrop(false);
                    props.getCounts();
                    refetch();
                });
        }
        else {
            var tipo = buttonText.includes("Carga") ? "FinishLoad" : "FinishUnload";
            history.replace(`/shedCheckout/${tipo}/${data![rowIndex].mvmId}/shed/${data![rowIndex].shedId}/movType/${data![rowIndex].movementTypeId}`);
        }
    }

    function CancelCargaClick(rowIndex: any, action: string, place: string) {

        const mvmShed = data[rowIndex];

        let dataPut: MvmShedStartLoadUnloadPut = {
            id: data![rowIndex].mvmId,
            sheds: [{
                id: data![rowIndex].mvmShedId
            }]
        }

        setOpenBackdrop(true);

        MvmApi.cancelStartShedLoadUnload(dataPut)
            .then(() => enqueueSnackbar(_t('returnSubmitDeleteFormSuccess'), { variant: 'success' }))
            .finally(() => {
                setOpenBackdrop(false);
                props.getCounts();
                refetch();
            })
    }

    function OnCancelClick(tableMeta: any, action: string, place: string) {

        const mvmShed = data[tableMeta.rowIndex];
        // return false;

        // let mvmShed = data?.find((mvm: { mvmCode: any; shedCode: any; }) => mvm.mvmCode == mvmCode && mvm.shedCode == shedCode);

        let dataPut = {
            Id: mvmShed?.mvmId,
            MvmShedIds: [mvmShed?.mvmShedId],
            action: action,
            place: place
        };

        setOpenBackdrop(true);

        //Atualizar para o back-end correto quando o mesmo estiver pronto
        MvmApi.recordMvmShed(dataPut)
            .then(() => enqueueSnackbar(_t('returnSubmitDeleteFormSuccess'), { variant: 'success' }))
            .finally(() => {
                setOpenBackdrop(false);
                refetch();
            })
    }

    const renderer = ({ hours, minutes, seconds, completed }: { hours: number, minutes: number, seconds: number, completed: boolean }) => {

        if (completed) {
            return <CountUp
                date={new Date(Date.now())}
                showSeconds={true} />;
        }
        else {
            return <span>{StringFormat.pad(hours, 2)}:{StringFormat.pad(minutes, 2)}:{StringFormat.pad(seconds, 2)}</span>;
        }

    };


    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className={classes.rootContent} style={{ margin: 0 }}>
                <div className={classes.paper}>

                    {

                        <MuiThemeProvider theme={myTheme}>
                            <MUIDataTable
                                title=""
                                data={data != null && data.length > 0 ? data : []}
                                columns={columns}
                                options={{
                                    ...options,
                                    serverSide: true,
                                    pagination: false,
                                    sort: false,
                                    selectToolbarPlacement: "none",
                                    filter: false,
                                    search: false,
                                    download: false,
                                    print: false,
                                    viewColumns: false,
                                    selectableRows: 'none',
                                }}
                            />
                        </MuiThemeProvider>
                    }
                </div>
            </div>
        </>
    )
}
export default CheckOut;
